import React, { FC } from 'react'
import { isMobileOnly } from 'react-device-detect'

import { ObserveButton } from '../../views'
import {
  getPickedColorCode,
  getPickedColorTitle,
  getPickedMaterial,
  getPriceToFixed
} from '../../pages'

import { getCurrencySymbol } from '../helpers'
import { Column } from '../column'
import { Text } from '../text'
import { Row } from '../row'

import { OrderLineOfferProps } from './order-line-offer.types'
import { useStyle } from './order-line-offer.styles'

export const OrderLineOffer: FC<OrderLineOfferProps> = ({
  className = '',
  offer,
  product,
  totalPrice,
  quantity
}) => {
  const classes = useStyle()
  const Container = isMobileOnly ? Column : Row
  const align = isMobileOnly ? 'center' : 'flex-stsrt'

  if (!product) {
    return <></>
  }

  const { name, pricing, thumbnail2x } = product
  const { currency } = pricing.priceRange.start.gross
  const symbolCurrency = getCurrencySymbol(currency)
  const totalPriceWithSymbol = symbolCurrency + getPriceToFixed(totalPrice)
  const material = offer && getPickedMaterial(offer.productMaterials)
  const colorCode = offer && getPickedColorCode(offer.productColors)
  const colorTitle = offer && getPickedColorTitle(offer.productColors)
  const itemPrice = offer ? offer.productTotalPrice : 0
  const unitPrice = `${symbolCurrency}${getPriceToFixed(itemPrice)}`
  const deliveryPrice = () => {
    if (!product.itemWeight) {
      return `${symbolCurrency}0`
    }

    return `${symbolCurrency}${getPriceToFixed(product.itemWeight.price)}`
  }

  return (
    <Column fullWidth className={className}>
      <Container
        fullWidth
        className={classes.line}
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Row alignItems="flex-start">
          <img
            className={classes.productAvatar}
            height="104px"
            width="104px"
            src={thumbnail2x?.url}
          />
          <Row fullWidth alignItems="flex-start" justifyContent="space-between">
            <Column alignItems="flex-start" className={classes.title}>
              <Text color="black" preset="h5" text={name} />
              {offer && (
                <ObserveButton
                  className={classes.observeOptionsBtn}
                  material={material}
                  colorCode={colorCode}
                  colorTitle={colorTitle}
                  offerOptions={offer.options}
                  productOptionsFromOffer={offer.productOptions}
                  nameTx="order.confirm.observe.options"
                />
              )}
            </Column>
          </Row>
        </Row>
        <Row
          fullWidth
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.infoRow}
        >
          <Column alignItems={align} className={classes.column}>
            <Text
              color="inactive"
              preset="body"
              text="Delivery Price"
              tx="order.line.product.delivery.price"
            />
            <Text color="black" preset="h7" text={deliveryPrice()} />
          </Column>
          <Column alignItems={align} className={classes.column}>
            <Text
              color="inactive"
              preset="body"
              text="Price"
              tx="order.line.product.price"
            />
            <Text color="black" preset="h7" text={unitPrice} />
          </Column>
          <Column alignItems={align} className={classes.column}>
            <Text
              color="inactive"
              preset="body"
              text="Quantity:"
              tx="order.item.product.quantity"
            />
            <Text
              className={classes.delivery}
              color="black"
              preset="h7"
              text={String(quantity)}
            />
          </Column>
          <Column alignItems={align} className={classes.column}>
            <Text
              color="inactive"
              preset="body"
              text="Total Price:"
              tx="order.item.total.price"
            />
            <Text
              className={classes.delivery}
              color="black"
              preset="h7"
              text={totalPriceWithSymbol}
            />
          </Column>
        </Row>
      </Container>
    </Column>
  )
}
